(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-password-content"]) return;
  try {
    
  document.querySelectorAll('[data-oc-password]').forEach((root) => {
    if (root.dataset.ocPasswordReady === 'true') return;
    root.dataset.ocPasswordReady = 'true';

    root.querySelectorAll('[data-oc-dialog-open]').forEach((button) => {
      button.addEventListener('click', () => {
        const dialog = root.querySelector(`[data-oc-dialog="${button.dataset.ocDialogOpen}"]`);
        if (dialog && !dialog.open) dialog.showModal();
      });
    });

    root.querySelectorAll('[data-oc-dialog]').forEach((dialog) => {
      const closeButton = dialog.querySelector('[data-oc-dialog-close]');
      if (closeButton) closeButton.addEventListener('click', () => dialog.close());
      dialog.addEventListener('click', (event) => {
        if (event.target === dialog) dialog.close();
      });
    });
  });

  } catch(e) { console.error(e); }
})();
})();
